import { setDataForApi } from "utils/api";
import { FormSchemaBrokerDetails } from "./types";

const parseDataForApi = (data: FormSchemaBrokerDetails) => {
  const _data = { ...data };
  setDataForApi(_data);
  return _data;
};

export default parseDataForApi;
